import { ExplorerApi } from './explorerApi';

export const explorerApi = new ExplorerApi()